/**
 * Controls whether or not users are enrolled into an experiment that makes the Insider communication a bit more * verbose on surfaces such as PDP, brand page and checkout
 */
export const VERBOSE_INSIDER_BENEFIT_LABELS_240311 = 'VERBOSE_INSIDER_BENEFIT_LABELS_240311';
